export default {
  computed: {
    tournament() {
      let id = this.$route.params.tournamentId;
			let tournaments = this.$store.state.upcomingTournaments;
			return tournaments.filter(t => t != null && t.id == id)[0];
    },
  }
}